import { QueryParamsModel } from '../../../_base/crud/models/query-models/query-params.model';
import { forkJoin } from 'rxjs';
// Angular
import { Injectable } from '@angular/core';
// RxJS
import { mergeMap, map, tap, delay } from 'rxjs/operators';
// NGRX
import { Effect, Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
// CRUD
import { QueryResultsModel } from '../../../_base/crud';
// Services
import { CustomerRateService } from '../_services/customerRate.service';
import { ShareddataserviceService } from '../../../../shared/shareddataservice.service';
// State
import { AppState } from '../../../../core/reducers';
// Actions
import {
    CustomerRateActionTypes,
    CustomerRatePageRequested,
    CustomerRatePageLoaded,
    OneCustomerRateDeleted,
    CustomerRateActionToggleLoading,
    CustomerRatePageToggleLoading,
    CustomerRateUpdated,
    CustomerRateStatusUpdated,
    CustomerRateCreated,
    CustomerRateOnServerCreated
} from '../_actions/customerRate.actions';
import { of } from 'rxjs';

@Injectable()
export class CustomerRateEffects {
    showPageLoadingDistpatcher = new CustomerRatePageToggleLoading({ isLoading: true });
    showActionLoadingDistpatcher = new CustomerRateActionToggleLoading({ isLoading: true });
    hideActionLoadingDistpatcher = new CustomerRateActionToggleLoading({ isLoading: false });

    @Effect()
    loadCustomerRatePage$ = this.actions$.pipe(
        ofType<CustomerRatePageRequested>(CustomerRateActionTypes.CustomerRatePageRequested),
        mergeMap(({ payload }) => {
            this.store.dispatch(this.showPageLoadingDistpatcher);
            const requestToServer = this.customerRateService.findCustomerRates(payload.page);
            const lastQuery = of(payload.page);
            return forkJoin(requestToServer, lastQuery);
        }),
        map(response => {
            const result: QueryResultsModel = response[0];
            const lastQuery: QueryParamsModel = response[1];

            this.sharedService.updateCustomerRateList(result.items);
            //console.log(result.items);
            const pageLoadedDispatch = new CustomerRatePageLoaded({
                customerRates: result.items,
                totalCount: result.totalCount,
                page: lastQuery
            });
            return pageLoadedDispatch;
        })
    );

    @Effect()
    deleteCustomerRate$ = this.actions$
        .pipe(
            ofType<OneCustomerRateDeleted>(CustomerRateActionTypes.OneCustomerRateDeleted),
            mergeMap(({ payload }) => {
                this.store.dispatch(this.showActionLoadingDistpatcher);
                return this.customerRateService.deleteCustomerRate(payload.CustRateId);
            }
            ),
            map(() => {
                return this.hideActionLoadingDistpatcher;
            }),
        );

    @Effect()
    updateCustomerRate$ = this.actions$
        .pipe(
            ofType<CustomerRateUpdated>(CustomerRateActionTypes.CustomerRateUpdated),
            mergeMap(({ payload }) => {
                this.store.dispatch(this.showActionLoadingDistpatcher);
                return this.customerRateService.updateCustomerRate(payload.customerRate.CustRateId, payload.customerRate);
            }),
            map(() => {
                return this.hideActionLoadingDistpatcher;
            })
        );

    @Effect()
    updateUserReviewsStatus$ = this.actions$
        .pipe(
            ofType<CustomerRateStatusUpdated>(CustomerRateActionTypes.CustomerRateStatusUpdated),
            mergeMap(({ payload }) => {
                this.store.dispatch(this.showActionLoadingDistpatcher);
                return this.customerRateService.updateStatusForCustomerRate(payload.customerRate, payload.ProductRate);
            }),
            map(() => {
                return this.hideActionLoadingDistpatcher;
            })
        );

    @Effect()
    createCustomerRate$ = this.actions$
        .pipe(
            ofType<CustomerRateOnServerCreated>(CustomerRateActionTypes.CustomerRateOnServerCreated),
            mergeMap(({ payload }) => {
                this.store.dispatch(this.showActionLoadingDistpatcher);
                return this.customerRateService.createCustomerRate(payload.customerRate).pipe(
                    tap(res => {
                        //console.log(res);
                        //const resValue = Object.keys(res).map(key => res[key]);
                        //console.log(resValue[0].value);
                        //this.store.dispatch(new CustomerRateCreated({ customerRate: res }));
                        if (res.CustRateId == 0) {
                            this.store.dispatch(new CustomerRateCreated({ customerRate: res }));
                        } else {
                            console.log('There is somthing wrong');
                            //this.store.dispatch(new CustomerRateErrorMessage({ _errorMessage: resValue[0].value }));
                        }

                    })
                );
            }),
            map(() => {
                return this.hideActionLoadingDistpatcher;
            }),
        );

    constructor(private actions$: Actions, private customerRateService: CustomerRateService,
        private sharedService: ShareddataserviceService, private store: Store<AppState>) { }
}
